// Egresos del gestor (7-oct-2026).
export const managementExpenses = {
  categories: {
    cleaning: "Pulizie",
    laundry: "Lavanderia",
    maintenance: "Manutenzione e riparazioni",
    supplies: "Forniture e materiali di consumo",
    utilities: "Utenze",
    staff: "Personale",
    software: "Software e strumenti",
    marketing: "Pubblicità",
    taxes: "Imposte e tasse",
    other: "Altro",
  },

  restricted: "Le spese di gestione sono visibili solo all'account principale: il tuo accesso è limitato ad alcuni alloggi.",

  summary: {
    aria: "Riepilogo delle spese del periodo. Seleziona una cifra per filtrare la tabella.",
    total: "Spese totali",
    count: "{n} spesa | {n} spese",
    charged: "Riaddebitate ai proprietari",
    chargedHint: "Detratte dai loro rendiconti",
    own: "Proprie della gestione",
    ownHint: "Riducono il tuo utile",
  },

  toolbar: {
    search: "Cerca",
    searchPlaceholder: "Descrizione o fornitore",
    clearSearch: "Cancella ricerca",
    category: "Categoria",
    allCategories: "Tutte",
    listing: "Alloggio",
    allListings: "Tutti",
    type: "Tipo",
    allTypes: "Tutte",
    charged: "Riaddebitate al proprietario",
    own: "Proprie",
    create: "Nuova spesa",
  },

  table: {
    date: "Data",
    category: "Categoria",
    concept: "Descrizione",
    listing: "Alloggio",
    chargedTo: "A carico di",
    amount: "Importo",
    receipt: "Ricevuta",
    actions: "Azioni",
    general: "Generale",
    management: "Gestione",
    ownerMissing: "Nessun proprietario assegnato",
    notCharged: "L'alloggio non è più in gestione: questa spesa non viene addebitata a nessuno",
    vat: "IVA {pct}%",
    download: "Scarica la ricevuta",
    edit: "Modifica",
    remove: "Elimina",
  },

  empty: {
    title: "Nessuna spesa in questo periodo",
    text: "Registra quello che paghi (pulizie, lavanderia, riparazioni, software…) e decidi se riaddebitarlo al proprietario o se è una spesa della gestione.",
    create: "Registra una spesa",
    filteredTitle: "Nessuna spesa corrisponde ai filtri",
    filteredText: "Prova con un'altra ricerca o rimuovi i filtri per vedere tutte le spese del periodo.",
    clear: "Rimuovi filtri",
  },

  load: {
    error: "Impossibile caricare le spese.",
    retry: "Riprova",
  },

  remove: {
    title: "Eliminare questa spesa?",
    message: "«{concept}» ({amount}) non verrà più conteggiata nelle analisi e nei rendiconti.",
    confirm: "Elimina",
    done: "Spesa eliminata",
    error: "Impossibile eliminare la spesa. Riprova.",
  },

  receiptError: "Impossibile scaricare la ricevuta.",

  drawer: {
    newTitle: "Nuova spesa",
    editTitle: "Modifica spesa",
    newSubtitle: "Quello che paghi per la gestione, a carico del proprietario o della tua società di gestione.",
    editSubtitle: "Le modifiche si riflettono subito nelle analisi e nei rendiconti.",
    close: "Chiudi",
    sections: {
      expense: "La spesa",
      listing: "Alloggio e proprietario",
      notes: "Note",
      receipt: "Ricevuta o fattura",
    },
    fields: {
      concept: "Descrizione",
      conceptPlaceholder: "Es.: Pulizia di fine soggiorno",
      category: "Categoria",
      date: "Data",
      supplier: "Fornitore",
      supplierPlaceholder: "Es.: Lavanderia Sole",
      amount: "Importo",
      vat: "IVA",
      vatHint: "Solo a titolo informativo: l'importo è quello che hai pagato, IVA inclusa.",
      listing: "Alloggio",
      listingGeneral: "Spesa generale della gestione (senza alloggio)",
      unit: "Unità",
      unitAll: "Tutto l'alloggio",
      notesPlaceholder: "Qualsiasi dettaglio che vuoi ricordare",
    },
    charge: {
      label: "Riaddebita al proprietario",
      general: "Una spesa generale è sempre a carico della gestione. Scegli un alloggio per addebitarla al suo proprietario.",
      loading: "Verifica dell'alloggio in corso…",
      error: "Non è stato possibile verificare se questo alloggio è in gestione.",
      retry: "Riprova",
      notManaged: "Questo alloggio non è contrassegnato come gestito: la spesa conta come tua.",
      notManagedMarked: "L'alloggio non è più in gestione: non viene addebitata a nessuno. Disattiva l'opzione per lasciarla come spesa propria.",
      own: "Se non la riaddebiti, conta come spesa propria della gestione.",
      owner: "Verrà detratta dal rendiconto di {owner}.",
      noOwner: "L'alloggio non ha ancora un proprietario assegnato: verrà detratta dal rendiconto di chi assegnerai.",
    },
    receipt: {
      drop: "Trascina qui la foto o il PDF",
      pick: "oppure scegli un file",
      formats: "JPG, PNG, WEBP, HEIC o PDF · max 10 MB",
      current: "Ricevuta salvata",
      download: "Scarica",
      change: "Sostituisci",
      remove: "Rimuovi",
      undo: "Annulla",
      willRemove: "La ricevuta verrà rimossa al salvataggio.",
      willReplace: "sostituirà quella salvata",
      tooBig: "Il file supera i 10 MB.",
      badType: "Formato non supportato: carica una foto (JPG, PNG, WEBP o HEIC) o un PDF.",
    },
    errors: {
      required: "Campo obbligatorio.",
      category: "Scegli una categoria.",
      amount: "Inserisci un importo maggiore di 0.",
      vat: "Inserisci una percentuale tra 0 e 100.",
      review: "Controlla i campi evidenziati.",
      generic: "Impossibile salvare la spesa. Riprova.",
    },
    discard: {
      title: "Annullare le modifiche?",
      message: "Quello che hai inserito per questa spesa andrà perso.",
      confirm: "Annulla modifiche",
      cancel: "Continua a modificare",
    },
    cancel: "Annulla",
    save: "Salva spesa",
    saveChanges: "Salva modifiche",
    saving: "Salvataggio…",
    created: "Spesa salvata",
    updated: "Modifiche salvate",
    outOfPeriod: "Salvata. La sua data ({date}) è fuori dal periodo che stai visualizzando.",
  },
};
